import { Arrangement } from './types.js';
import { toArrangement } from './utils.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/**
 * Preferred video arrangement.
 *
 * @returns Video arrangement.
 */
export const useArrangementPref = (): UsePrefState<Arrangement> =>
  usePrefState('video.arrangement.selected', Arrangement.Single, {
    deserialize: toArrangement
  });
